// extracted by mini-css-extract-plugin
export var subtitle = "_db-2";
export var title = "_db-0";
export var titleNoWrap = "_db-1";